<template>
	<AppSelect
		outlined
		hide-details
		item-value="name"
		@change="onChange"
		placeholder="Select your data center region"
		:value="selectedRegion"
		:items="regions"
		:menu-props="{ bottom: true, offsetY: true, contentClass: 'apps-select-empty-state-menu' }"
	>
		<template v-slot:selection="{ item }">
			<div v-if="item" class="selected-app flex-centerize py-[10px]">
				<h3>{{ item.name }}</h3>
			</div>
		</template>
		<template v-slot:item="{ item }">
			<div v-if="item" class="selection-row flex-centerize py-[10px]">
				<h3>{{ item.name }}</h3>
			</div>
		</template>
	</AppSelect>
</template>

<script>
export default {
	name: 'RegionSelect',
	props: {
		selectedRegion: { type: String },
	},
	methods: {
		onChange(region) {
			this.$emit('on-region-selected', region);
		},
	},
	data() {
		return {
			regions: [
				{
					name: 'United States',
				},
				{
					name: 'Europe',
				},
			],
		};
	},
};
</script>

<style lang="scss"></style>
